import { render, staticRenderFns } from "./DocumentacionPage.vue?vue&type=template&id=a6c12888"
import script from "./DocumentacionPage.js?vue&type=script&lang=js&external"
export * from "./DocumentacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports